export default __webpack_public_path__ + "static/media/cd.af7f42f2.svg";